module.exports = __webpack_public_path__ + "img/studyImg.3669d4a8.png";